import {
  carrosselSlides as slidesDefault,
  shortsDoClube as shortsDefault,
  agendaDoMes as agendaDefault,
} from '../config/homeConfig';

const SHEET_URL =
  'https://docs.google.com/spreadsheets/d/1bnJ01GZgR4Ayyl2lA-XdVgSCtd6XXT3j/export?format=csv&gid=593648761';

function parseCSVLine(line) {
  const result = [];
  let current = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      inQuotes = !inQuotes;
    } else if (ch === ',' && !inQuotes) {
      result.push(current);
      current = '';
    } else {
      current += ch;
    }
  }
  result.push(current);
  return result;
}

export async function buscarConteudoHome() {
  try {
    const res = await fetch(SHEET_URL, { cache: 'no-store' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const text = await res.text();
    const lines = text.trim().split('\n');
    if (lines.length < 2) throw new Error('Planilha vazia');

    const headers = parseCSVLine(lines[0]).map(h => h.trim());
    const rows = lines.slice(1).map(line => {
      const cols = parseCSVLine(line);
      const obj = {};
      headers.forEach((h, i) => { obj[h] = (cols[i] || '').trim(); });
      return obj;
    }).filter(r => (r.ativo || '').toLowerCase() !== 'não');

    const carrosselSlides = rows
      .filter(r => r.tipo === 'carrossel')
      .map(r => ({
        id: r.id,
        titulo: r.titulo,
        subtitulo: r.subtitulo || undefined,
        imagem: r.imagem || null,
        corFundo: r.corFundo || '#2f2b5f',
        cta: r.cta || undefined,
        link: r.link || undefined,
      }));

    const shortsDoClube = rows
      .filter(r => r.tipo === 'shorts')
      .map(r => ({
        id: r.id,
        titulo: r.titulo,
        thumbnail: r.thumbnail || null,
        link: r.link,
      }));

    const agendaDoMes = rows
      .filter(r => r.tipo === 'agenda')
      .map(r => ({
        id: r.id,
        titulo: r.titulo,
        data: r.data,
        tipo: r.tipo_evento,
        link: r.link || undefined,
      }));

    return { carrosselSlides, shortsDoClube, agendaDoMes };
  } catch (err) {
    console.warn('[homeContent] usando fallback estático:', err.message);
    return {
      carrosselSlides: slidesDefault,
      shortsDoClube: shortsDefault,
      agendaDoMes: agendaDefault,
    };
  }
}
